/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-14T11:53:42-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { CountryDropdown } from 'react-country-region-selector';
import { box, textColor, type } from '../../style';
import glamorous, { Div } from 'glamorous';

const style = StyleSheet.create({
  select: {
      padding: '10px',
      paddingRight:'26px',
      appearance: 'none',
      border: 'none',
      backgroundColor: 'transparent',
      display: 'inline-block',
      ...type.MD,

      [':focus']: {
        outline: 'none'
      }
  },
  fit: {
    width: '100%'
  },
});


const Arrow = glamorous.span({
    position: 'absolute',
    pointerEvents: 'none'
}, (({top, right, lineHeight}) => ({
    top: typeof top === 'number' ? top : null,
    right: typeof right === 'number' ? right : null,
    lineHeight: typeof lineHeight === 'number' ? lineHeight : null
})))

const defaultArrow = (
    <Arrow top={12} right={8} lineHeight={0}>
      <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" style={{fill:'#484848', display:'block',}} viewBox="0 0 24 24"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/></svg>
    </Arrow>
)

// MT Retheme caret
const lightArrow = (
<Arrow top={0} right={0}>
<svg width='12' height='7' viewBox='0 0 12 7' xmlns='http://www.w3.org/2000/svg'>
    <g id='Page-1' fill='none' fillRule='evenodd'>
        <g id='Search---Results---People' transform='translate(-849 -124)' fill='#B9B9B9'>
            <g id='Search' transform='translate(0 60)'>
                <g id='Sentence-Copy' transform='translate(88 48)'>
                    <g id='Caret-/-Down' transform='translate(761 16)'>
                        <polygon id='Caret---Down' points='1.09090909 4.32862413e-14 0 1.07692308 6 7 12 1.07692308 10.9090909 4.32862413e-14 6 4.84615385'
                        />
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg></Arrow>)

const arrowStyle = (style) => {
  if (style === "light") {
    return lightArrow
  }
  else return defaultArrow
}

const countryDropdownStyle = (countryDropdown) => {
    if (countryDropdown) return {
    maxWidth: '100%',
    overflow: 'hidden'
    }
  }

const SelectContainer = glamorous.div({
    position: 'relative',
    display: 'inline-block',
    ...box,
  },
  (({fit, error, countryDropdown, dropdownStyle}) => ({
    width: fit && "100%",
    borderColor: error && textColor.RED.color,
    border: dropdownStyle === 'mt-purple' && "none",
    ...countryDropdownStyle(countryDropdown),
  }))
)

const customStyle = (dropdownStyle, options) => {
  if (dropdownStyle === "mt-purple") {
    return {
      color: "#CAB4FF",
      fontFamily: "'PT Serif', serif",
      fontSize: (options && options.fontSize) ? options.fontSize : 24,
      padding: 0,
      borderRadius: 0,
      width: (options && options.width) ? options.width : "inherit",
      borderBottom: '1px dashed #979797',
      paddingBottom: 1,
      '@media (max-width: 320px)': {
        fontSize: (options && options.fontSize) ? options.fontSize : 22
      }
    }
  }
}

const CustomDropdown = glamorous.select(
  {
  padding: '10px',
  paddingRight:'26px',
  appearance: 'none',
  border: 'none',
  backgroundColor: 'transparent',
  display: 'inline-block',
  ...type.MD,

  [':focus']: {
    outline: 'none'
  },
  },
  (({ dropdownStyle, options, fit }) => ({
    width: fit && "100%",
    ...customStyle(dropdownStyle, options)
  }))
)

const Select = (props) => {

  const {
    fit,
    error,
    countryDropdown,
    arrow,
    dropdownStyle,
    dropdownStyleOptions,
    ...rest
  } = props


  const selectElem = countryDropdown
    ? <CountryDropdown classes={css(style.select, props.fit && style.fit)} {...rest} />
    : (<CustomDropdown
        dropdownStyle={dropdownStyle}
        options={dropdownStyleOptions}
        fit={fit}
        {...rest}>
          {props.children}
      </CustomDropdown>)
  return (
    <SelectContainer
      fit={fit}
      error={error}
      countryDropdown={countryDropdown}
      dropdownStyle={dropdownStyle}
      >
    <Div width={(props.fit ? "100%" : null)}>
        {selectElem}
    </Div>
    {arrowStyle(arrow)}
  </SelectContainer>
  )
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/common/Select.jsx